import { combineReducers } from 'redux'

import site from '../ducks/site/site'
import coupon20k from '../ducks/coupon-20k/coupon-20k'
import promotion from '../ducks/promotion/promotion'
import tripPrice from '../ducks/trip-price/trip-price'
import ticketSale from '../ducks/ticket-sale/ticket-sale'
import tripSearch from '../ducks/trip-search/trip-search'
import authentication from '../ducks/authentication/authentication'
import bonusPoints from '../ducks/bonus-points/bonus-points'
import progressBar from '../ducks/progress-bar/progress-bar'
import userReducer from './user.reducer'
import adminReducer from './admin.reducer'
import toastReducer from './toast.reducer'
import clientReducer from './client.reducer'
import ticketConsult from '../ducks/ticket-consult/ticket-consult'
import partnerReducer from './partner.reducer'
import addressesReducer from './addresses.reducer'
import newsletterOption from '../ducks/newsletter-option/newsletter-option'
import antiFraudReducer from './anti-fraud.reducer'
import clientTicketModal from '../ducks/client-ticket-modal/client-ticket-modal'
import creditCardPurchase from '../ducks/credit-card-purchase/credit-card-purchase'
import creditCardsReducer from './credit-cards.reducer'
import busSeatSelectionReducer from './bus-seat-selection.reducer'
import debitCardPurchase from '../ducks/debit-card-purchase/debit-card-purchase'
import muvicardPurchase from '../ducks/muvicard-purchase/muvicard-purchase'

import conexao from '../ducks/conexao/conexaoReducer'

const createReducer = (reducers) =>
	combineReducers({
		...{
			site,
			promotion,
			tripPrice,
			coupon20k,
			ticketSale,
			tripSearch,
			bonusPoints,
			progressBar,
			ticketConsult,
			authentication,
			newsletterOption,
			clientTicketModal,
			user: userReducer,
			creditCardPurchase,
			admin: adminReducer,
			toast: toastReducer,
			client: clientReducer,
			partner: partnerReducer,
			addresses: addressesReducer,
			antiFraud: antiFraudReducer,
			creditCards: creditCardsReducer,
			busSeatSelection: busSeatSelectionReducer,
			debitCardPurchase,
			conexao,
			muvicardPurchase,
		},
		...reducers,
	})

const registerReducer = (store, name, reducer) => {
	if (!reducer) return
	store.async[name] = reducer
	store.replaceReducer(createReducer(store.async))
}

export { createReducer, registerReducer }
